import screen from './screen';

export default {
  namespaced: true,
  modules: {
    screen,
  },
  state: () => ({
    userAgent: null,
    type     : null,
  }),
  mutations: {
    setUserAgent(state, { userAgent }) {
      state.userAgent = userAgent;
    },
  },
  actions: {
    initialize({ commit, dispatch }, device = {}) {
      commit('setUserAgent', { userAgent: device.userAgent || window.navigator.userAgent });
      dispatch('screen/initialize');
    },
  },
};
